import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['counter', 'wait', 'resend']
  static values = { seconds: Number }

  connect () {
    if (this.secondsValue > 0) {
      this.#tick()
    } else {
      this.#showResend()
    }
  }

  disconnect () {
    clearTimeout(this.#timer)
  }

  // private

  #timer = null

  #tick () {
    this.counterTarget.textContent = this.secondsValue

    if (this.secondsValue <= 0) {
      this.#showResend()
      return
    }

    this.secondsValue -= 1
    this.#timer = setTimeout(() => this.#tick(), 1000)
  }

  #showResend () {
    this.waitTarget.hidden = true
    this.resendTarget.hidden = false
  }
}
